function updateLinkForRechargeToken(elementId, link, title, icon) {
    $('a#' + elementId).replaceWith(`
        <a class="nav-link" href="${link}">
            <img src="https://cdn.shopify.com/s/files/1/0256/8926/0111/files/icon-${icon}.png?v=1601912754" alt="">
                ${title}
        </a>`);
    $('a#' + elementId + '-mobile').replaceWith(`<a class="btn plus-btn collapsed" href="${link}"></a>`);
}

window.addEventListener("load", () => {
    const decodeParams      = '?' + atob(document.location.search.slice(1));
    const decodeURL         = document.location.origin + document.location.pathname + decodeParams;
    const parameters        = new URL(decodeURL).searchParams;
    const email             = parameters.get('email');
    const firstname         = parameters.get('firstname');
    const lastname          = parameters.get('lastname');
    const customerToken     = parameters.get('customerToken');
    const customerId        = parameters.get('customerId');
    const baseUrlRecharge   = "/tools/recurring/portal/"; 

    if (firstname && lastname && email && customerToken && customerId)
    {
      $('#my-account__title').html('Bonjour ' + firstname + '!');
      updateLinkForRechargeToken("history", `${baseUrlRecharge}${customerId}/orders?token=${customerToken}`, "Historique d'achat", "historique");
      updateLinkForRechargeToken("subscription", `${baseUrlRecharge}${customerId}/subscriptions?token=${customerToken}`, "Abonnements", "abbonements");
      updateLinkForRechargeToken("customer", `${baseUrlRecharge}${customerId}/payment_sources?token=${customerToken}`, "Détails du compte", "details");
      $('head').append(`<script type="text/javascript" src="https://tag.mention-me.com/api/v2/dashboard/mm2359cccc/${encodeURI(email)}?firstname=${encodeURI(firstname)}&amp;surname=${encodeURI(lastname)}&amp;locale=fr_FR"/>`);
    }
    else {
      window.location.href = "/account/login?checkout_url=/tools/recurring/login";
    }
  });